/* Teksty interfejsu: assets/json/i18n/{lang}/js-runtime.json. */
function jst(key, params) {
    var api = typeof globalThis !== 'undefined' ? globalThis.PewniakiI18n : null;
    if (api && typeof api.t === 'function') return api.t(key, params);
    if (typeof module === 'object' && module.exports && typeof require === 'function') {
        var lang = typeof document !== 'undefined' && /^en(?:-|$)/i.test(document.documentElement.lang || '') ? 'en' : 'pl';
        var dict = require('../../json/i18n/' + lang + '/js-runtime.json');
        var text = Object.prototype.hasOwnProperty.call(dict, key) ? String(dict[key]) : key;
        return (params || []).reduce(function (out, value, index) { return out.split('%' + (index + 1)).join(String(value)); }, text);
    }
    return key;
}

/* Roczniki: tryb Roczniki/Ostatnie losowania i liczebnosc rankingow 2..10.
   Okna obsluguje wspolny analiza.js — my dajemy mu tylko render/wnioski. */
(function () {
    'use strict';

    function enText(pl, en) { return typeof document !== 'undefined' && /^en(?:-|$)/i.test(document.documentElement.lang || '') ? en : pl; }

    /* Kontrakty danych sa rozne: rok ma main:{n:hits}, okno ma liczby:{n:{hits}}.
       Okno z powodem lub bez mapy liczb to brak danych, nie ranking zer. */
    function oknoDoProby(o) {
        if (!o || typeof o !== 'object' || o.powod || !o.liczby || typeof o.liczby !== 'object') return null;
        var klucze = Object.keys(o.liczby);
        if (!klucze.length) return null;
        var main = {};
        klucze.forEach(function (k) { var h = Number(o.liczby[k] && o.liczby[k].hits); main[k] = h > 0 ? h : 0; });
        return { losowan: Number(o.losowan) || 0, main: main };
    }

    function rank(sample, pool, limit, kind) {
        if (!sample || typeof sample !== 'object' || !sample.main || typeof sample.main !== 'object') return null;
        var main = sample.main, N = Number(sample.losowan), lim = Math.floor(Number(limit)), P = Math.floor(Number(pool));
        if (!(N > 0) || !(lim > 0) || !Object.keys(main).length) return null;
        if (!(P > 0)) P = Object.keys(main).reduce(function (m, k) { return Math.max(m, Number(k) || 0); }, 0);
        if (!(P > 0)) return null;
        var lista = [];
        for (var n = 1; n <= P; n++) { var h = Number(main[n]); h = h > 0 ? h : 0; lista.push({ n: n, hits: h, rate: h / N }); }
        var znak = kind === 'bottom' ? 1 : -1;
        lista.sort(function (a, b) { return a.hits === b.hits ? a.n - b.n : znak * (a.hits - b.hits); });
        return lista.slice(0, lim);
    }

    function normalize(params, allowed) {
        allowed = Array.isArray(allowed) ? allowed : [];
        function get(k) { return params && typeof params.get === 'function' ? params.get(k) : null; }
        function cale(v, def) { return /^(?:[2-9]|10)$/.test(String(v)) ? Number(v) : def; }
        var okno = get('okno');
        if (allowed.indexOf(okno) < 0) okno = allowed.indexOf('50') >= 0 ? '50' : (allowed[0] || null);
        return {
            top: cale(get('top'), 5),
            bottom: cale(get('bottom'), 3),
            widok: get('widok') === 'okna' ? 'okna' : 'roczniki',
            okno: okno
        };
    }

    window.PEWNIAKI_ROC = { rank: rank, normalize: normalize, oknoDoProby: oknoDoProby };

    var root = document.querySelector('[data-roc-root]');
    if (!root) return;

    var dane = {};
    try { dane = JSON.parse((root.querySelector('[data-roc-data]') || {}).textContent || '{}') || {}; } catch (e) { dane = {}; }

    var years = root.querySelector('[data-roc-years]'), windows = root.querySelector('[data-roc-windows]');
    var selMode = root.querySelector('[data-roc-mode]'), selTop = root.querySelector('[data-roc-top]'), selBottom = root.querySelector('[data-roc-bottom]');
    var listaWn = document.querySelector('[data-analiza-wnioski] .wniosek__lista');
    var ssrWnioski = listaWn ? Array.from(listaWn.querySelectorAll('.wniosek__zdanie'), function (s) { return s.textContent; }) : [];

    var kod = (function () {
        var k = root.querySelector('[data-roc-list] .kula');
        var c = k && k.className.split(/\s+/).find(function (x) { return /^kula--/.test(x) && !/^kula--(?:mala|duza|specjalna|trafiona)$/.test(x); });
        return c ? c.slice(6) : 'lotto';
    })();

    /* Parametry gry: z danych, w odwodzie ze wzoru wyrenderowanego przez serwer, pula ostatecznie z kluczy. */
    var pula = Number(dane.pula) || 0, typuje = Number(dane.typuje) || 0;
    var wzor = years && /(?:losowań|draws) × (\d+) \/ (\d+)/.exec(years.textContent);
    if (wzor) { typuje = typuje || Number(wzor[1]); pula = pula || Number(wzor[2]); }
    if (!pula) {
        [dane.lata || {}, dane.okna || {}].forEach(function (zbior) {
            Object.keys(zbior).forEach(function (k) {
                var m = (zbior[k] && (zbior[k].main || zbior[k].liczby)) || {};
                Object.keys(m).forEach(function (n) { pula = Math.max(pula, Number(n) || 0); });
            });
        });
    }

    var dozwolone = Object.keys(dane.okna || {}).filter(function (k) { var p = oknoDoProby(dane.okna[k]); return p && p.losowan > 0; });
    var lim = normalize(new URL(location.href).searchParams, dozwolone);
    var stan = { o: null, key: null };

    function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
    function fmtLiczba(x) { return String(x).replace(/\B(?=(\d{3})+(?!\d))/g, ' '); }
    function fmtDec(x, d) { var s = Number(x).toFixed(d).split('.'); return fmtLiczba(s[0]) + ',' + s[1]; }
    function slowo(k, typ) { return typ === 'top' ? (k <= 4 ? jst("pages_roczniki_rankingi_js.28eacad3cc5c") : jst("pages_roczniki_rankingi_js.2674729fa60a")) : (k <= 4 ? jst("pages_roczniki_rankingi_js.a89adf1eb48f") : jst("pages_roczniki_rankingi_js.2110d1c4c411")); }
    function oczekiwane(N) { return pula > 0 && typuje > 0 && N > 0 ? N * typuje / pula : null; }

    function listaRankingu(lista, los, typ) {
        var ul = el('ul', "kule kule--zwarte");
        ul.setAttribute('data-roc-list', typ); ul.setAttribute('role', 'list'); ul.classList.add('lista-rankingowa');
        lista.forEach(function (p) {
            var proc = los > 0 ? 100 * p.hits / los : 0;
            var li = el('li', 'kula-z-podpisem'); li.setAttribute('data-roc-number', p.n); li.setAttribute('data-roc-hits', p.hits);
            var kula = el('span', "kula kula--mala kula--" + kod, String(p.n)); kula.setAttribute('aria-label', jst("pages_roczniki_rankingi_js.3e2682c8b372") + p.n);
            var pod = el('span', "tekst-maly liczbowa");
            var h = el('span', null, String(p.hits)); h.setAttribute('data-roc-hits-value', '');
            var r = el('span', null, proc.toFixed(1).replace('.', ',') + '\u00a0%'); r.setAttribute('data-roc-rate', proc.toFixed(1));
            pod.appendChild(h); pod.appendChild(document.createTextNode('× · ')); pod.appendChild(r);
            li.appendChild(kula); li.appendChild(pod); ul.appendChild(li);
        });
        return ul;
    }

    /* Liczba najczesciej obecna w rocznym TOP — ta sama regula remisu co w rankingach. */
    function topRoczny() {
        var licz = {}, lat = 0, best = null;
        Object.keys(dane.lata || {}).forEach(function (rok) {
            var t = rank(dane.lata[rok], pula, lim.top, 'top');
            if (!t) return;
            lat++;
            t.forEach(function (p) { licz[p.n] = (licz[p.n] || 0) + 1; });
        });
        Object.keys(licz).forEach(function (k) {
            var n = Number(k), ile = licz[k];
            if (!best || ile > best.ile || (ile === best.ile && n < best.n)) best = { n: n, ile: ile };
        });
        return { best: best, lat: lat };
    }

    function odswiezLata() {
        if (!years) return;
        years.querySelectorAll('tr[data-roc-sample^="rok-"]').forEach(function (tr) {
            var r = dane.lata && dane.lata[tr.getAttribute('data-roc-sample').slice(4)];
            var uTop = tr.querySelector('[data-roc-list="top"]'), uBot = tr.querySelector('[data-roc-list="bottom"]');
            var top = r && rank(r, pula, lim.top, 'top'), bot = r && rank(r, pula, lim.bottom, 'bottom');
            if (!uTop || !uBot || !top || !bot) return;
            uTop.replaceWith(listaRankingu(top, r.losowan, 'top'));
            uBot.replaceWith(listaRankingu(bot, r.losowan, 'bottom'));
        });
        var th = years.querySelectorAll('thead th');
        if (th[3]) { th[2].textContent = lim.top + ' ' + slowo(lim.top, 'top'); th[3].textContent = lim.bottom + ' ' + slowo(lim.bottom, 'bottom'); }
        var intro = years.querySelector('h2 + p');
        if (intro) intro.textContent = intro.textContent.replace(/\d+ (?:najczęściej padających|most frequent)/, lim.top + jst("pages_roczniki_rankingi_js.0bcedaba5822")).replace(/\d+ (?:najrzadszych|least frequent)/, lim.bottom + jst("pages_roczniki_rankingi_js.d40700a21b14"));
        var kafel = years.querySelectorAll('.wynik-kafel')[2];
        if (kafel) {
            var t = topRoczny(), b = t.best;
            kafel.querRuntime = null;
            kafel.querySelector('.wynik-kafel__etykieta').textContent = jst("pages_roczniki_rankingi_js.3675a1073e5a") + lim.top;
            kafel.querySelector('.wynik-kafel__wartosc').textContent = b ? String(b.n) : '—';
            kafel.querySelector('.tekst-maly').textContent = b ? b.ile + jst("pages_roczniki_rankingi_js.f9d730f3294a") + t.lat + jst("pages_roczniki_rankingi_js.ff0a5984397a") : jst("pages_roczniki_rankingi_js.16b818eaf58b");
        }
    }

    function kartaOkna() {
        var k = windows.querySelector('[data-roc-sample^="okno-"]');
        if (k) return k;
        var kom = windows.querySelector(':scope > .komunikat');
        if (kom) kom.hidden = true;
        k = el('div', "karta karta--cicha o-2"); k.classList.add('styl-92c18f6bda');
        windows.appendChild(k);
        return k;
    }

    function nazwaProby(key) {
        if (key === 'all') return jst("pages_roczniki_rankingi_js.9deb91527251");
        if (key === 'lata') return jst("pages_roczniki_rankingi_js.ae24e6f6237a");
        return /^\d+$/.test(String(key)) ? jst("pages_roczniki_rankingi_js.8f30801d7e6a") + key + jst("pages_roczniki_rankingi_js.9dbb70a391d8") : jst("pages_roczniki_rankingi_js.8213e95dc2dc");
    }

    function renderOkno(o, key) {
        if (!windows) return;
        stan.o = o; stan.key = key;
        var karta = kartaOkna(), proba = oknoDoProby(o), N = proba ? proba.losowan : 0, e = oczekiwane(N);
        karta.setAttribute('data-roc-sample', 'okno-' + key);
        karta.replaceChildren(el('h3', null, nazwaProby(key)));
        var p = el('p', 'tekst-maly', jst("pages_roczniki_rankingi_js.fc038f1cd149"));
        var strong = el('strong', null, String(N)); strong.setAttribute('data-roc-n', ''); p.appendChild(strong);
        if (e != null) p.appendChild(document.createTextNode(jst("pages_roczniki_rankingi_js.57953eeab335") + N + ' × ' + typuje + ' / ' + pula + ' = ' + fmtDec(e, 1)));
        karta.appendChild(p);
        var top = proba && rank(proba, pula, lim.top, 'top'), bot = proba && rank(proba, pula, lim.bottom, 'bottom');
        if (!top || !bot) {
            var kom = el('div', "komunikat komunikat--info");
            kom.appendChild(el('p', null, o ? jst("pages_roczniki_rankingi_js.a7ffe95b3041") : jst("pages_roczniki_rankingi_js.d697fbda8dfa")));
            karta.appendChild(kom);
            return;
        }
        [['top', top], ['bottom', bot]].forEach(function (para) {
            var k = para[0] === 'top' ? lim.top : lim.bottom;
            var h4 = el('h4', 'tekst-maly', k + ' ' + slowo(k, para[0])); h4.classList.add('styl-0ee7f66ad9');
            karta.appendChild(h4); karta.appendChild(listaRankingu(para[1], N, para[0]));
        });
    }

    function wnioskiOkna(o) {
        var proba = oknoDoProby(o), top = proba && rank(proba, pula, 1, 'top'), bot = proba && rank(proba, pula, 1, 'bottom');
        if (!top || !bot) return [jst("pages_roczniki_rankingi_js.6a31c10571cc")];
        var N = proba.losowan, e = oczekiwane(N), dop = e != null ? jst("pages_roczniki_rankingi_js.b068f25e8f3f") + fmtDec(e, 1) + jst("pages_roczniki_rankingi_js.ab49f92bbc48") : '';
        return [
            jst("pages_roczniki_rankingi_js.5b8a083f9730") + fmtLiczba(N) + jst("pages_roczniki_rankingi_js.29897451ac36") + top[0].n + ': ' + top[0].hits + jst("pages_roczniki_rankingi_js.579979de2d70") + (100 * top[0].rate).toFixed(1).replace('.', ',') + ' %)' + dop + '.',
            jst("pages_roczniki_rankingi_js.99a5449bf0a5") + bot[0].n + ': ' + bot[0].hits + jst("pages_roczniki_rankingi_js.579979de2d70") + (100 * bot[0].rate).toFixed(1).replace('.', ',') + ' %)' + dop + '.',
            jst("pages_roczniki_rankingi_js.d5f6c6394ec6") + pula + jst("pages_roczniki_rankingi_js.226ac67b1bc2")
        ];
    }

    /* Punkty roczne pochodza z SSR; przelicza sie tylko ten zalezny od liczebnosci TOP. */
    function wnioskiLat() {
        var pkt = ssrWnioski.filter(function (t) { return !/najczęściej trafiała do rocznej listy|most often appeared in the annual top/.test(t) && t !== jst("pages_roczniki_rankingi_js.27214495573d"); });
        var t = topRoczny();
        if (t.best) pkt.push(jst("pages_roczniki_rankingi_js.5e32fa743b3b") + t.best.n + jst("pages_roczniki_rankingi_js.4f665ff059aa") + lim.top + jst("pages_roczniki_rankingi_js.3829f612c25f") + t.best.ile + jst("pages_roczniki_rankingi_js.f9d730f3294a") + t.lat + jst("pages_roczniki_rankingi_js.94c361fc471e"));
        return pkt.length ? pkt : [jst("pages_roczniki_rankingi_js.27214495573d")];
    }

    function pokazWnioski() {
        if (!listaWn) return;
        listaWn.replaceChildren();
        (lim.widok === 'okna' ? wnioskiOkna(stan.o) : wnioskiLat()).forEach(function (t) {
            var li = el('li', 'wniosek__punkt'); li.appendChild(el('span', 'wniosek__zdanie', String(t))); listaWn.appendChild(li);
        });
    }

    function zastosujTryb() {
        if (years) years.hidden = lim.widok !== 'roczniki';
        if (windows) windows.hidden = lim.widok !== 'okna';
        var period = document.querySelector('[data-roc-period]');
        if (period) period.hidden = lim.widok !== 'okna';
    }

    function adres() {
        var u = new URL(location.href);
        u.searchParams.set('widok', lim.widok); u.searchParams.set('top', lim.top); u.searchParams.set('bottom', lim.bottom);
        history.replaceState(null, '', u.pathname + u.search + u.hash);
    }

    var api = window.PEWNIAKI_ANALIZA = window.PEWNIAKI_ANALIZA || {};
    if (!api.plik && root.getAttribute('data-roc-plik')) api.plik = root.getAttribute('data-roc-plik');
    if (!api.wersja) api.wersja = dane.policzono || '';
    api.render = function (o, key) { renderOkno(o, key); };
    api.wnioski = function (o) { stan.o = o; return lim.widok === 'okna' ? wnioskiOkna(o) : wnioskiLat(); };

    /* Stan startowy to karta wyrenderowana przez serwer. */
    var ssrKarta = windows && windows.querySelector('[data-roc-sample^="okno-"]');
    if (ssrKarta) { stan.key = ssrKarta.getAttribute('data-roc-sample').slice(5); stan.o = dane.okna ? dane.okna[stan.key] : null; }

    if (selMode) selMode.value = lim.widok;
    if (selTop) selTop.value = String(lim.top);
    if (selBottom) selBottom.value = String(lim.bottom);
    zastosujTryb();

    var ssrTop = ssrKarta && ssrKarta.querySelectorAll('[data-roc-list="top"] li').length;
    if ((ssrTop && ssrTop !== lim.top) || (years && years.querySelector('[data-roc-list="top"]') && years.querySelector('[data-roc-list="top"] li:nth-child(' + lim.top + ')') === null)) {
        odswiezLata(); if (stan.key) renderOkno(stan.o, stan.key); pokazWnioski();
    } else if (lim.widok === 'okna') {
        pokazWnioski();
    }

    if (selMode) selMode.addEventListener('change', function () { lim.widok = selMode.value === 'okna' ? 'okna' : 'roczniki'; zastosujTryb(); adres(); pokazWnioski(); });
    function zmianaLimitu() {
        lim.top = normalize(new URLSearchParams({ top: selTop ? selTop.value : '' })).top;
        lim.bottom = normalize(new URLSearchParams({ bottom: selBottom ? selBottom.value : '' })).bottom;
        odswiezLata(); if (stan.key) renderOkno(stan.o, stan.key); adres(); pokazWnioski();
    }
    if (selTop) selTop.addEventListener('change', zmianaLimitu);
    if (selBottom) selBottom.addEventListener('change', zmianaLimitu);
})();
